import { ToDo } from "../../Components/ToDo";
import { TimeUtils } from "../../Utils/TimeUtils";
import { Step } from "../Step/Step";
import { Cash } from "../Step/Cash";
import { StepEvent, StepEventType } from "../Step/StepEvent";
import { StepType } from "../Step/StepType";
import { ManaPostalDeliveryStepState } from "./Models/ManaPostalDeliveryStepState";
import { ManaPostalDeliveryStepData } from "./Models/ManaPostalDeliveryStepData";
import moment from "moment";
import { Line } from "@tblabs/truffle";
import { CashType } from "../Step/CashType";


export class ManaPostalDeliveryStep extends Step<ManaPostalDeliveryStepState>
{
    public Type = StepType.ManaPostalDelivery;
    public Icon = "💰";
    public TitleForCustomer = () => ``;
    public Title = () => `Przekaz pieniężny`;
    public IsVisibleForCustomer = false;

    public InitialState = ManaPostalDeliveryStepState.Awaiting;
    public WellDoneStates = [ManaPostalDeliveryStepState.Delivered];
    public FailedDoneStates = [];

    public get AsEvents(): StepEvent[]
    {
        return [
            new StepEvent(StepEventType.ManaPostalDelivery, this.Order.Id, "💰", "Przekaz pieniężny", this.Data.DeliveryDeadline.value, this.IsDone, false)
        ];
    }
    public get Mana(): Cash[]
    {
        const cash: Cash[] = [];

        if (this.Data.State.Is(ManaPostalDeliveryStepState.Delivered))
        {
            cash.push(new Cash(CashType.ReceivedIncome, this, this.Data.Amount.value, "Przekaz pieniężny", new Date(+this.Data.DeliveryTime.value || +this.Data.DeliveryDeadline.value)))
        }

        return cash;
    }
    public get WhenPlanned(): Date
    {
        return this.Data.DeliveryDeadline.value;
    }
    public get WhenDone(): Date
    {
        return this.Data.DeliveryTime.value;
    }

    constructor(public Data: ManaPostalDeliveryStepData)
    {
        super(Data);
    }

    public STATES = {
        [ManaPostalDeliveryStepState.Awaiting]: {
            StateName: "Oczekuje",
            Timeout: () => this.Data.DeliveryDeadline,
            Admin: {
                Content: () => [
                    `Pieniądze (${this.Data.Amount.value} zł) powinny zostać dostarczone przez listonosza pod adres nadania do mniej więcej ${TimeUtils.FormattedDate(this.Data.DeliveryDeadline)} (o ile paczka została nadana i odebrana)`,
                    new Line(),
                    `Number paczki jest widoczny w kroku Wysyłki`,
                    new ToDo(`Kliknij ptaszka jeśli pieniądze dotarły.\nJeśli nie - sprawdź czy w skrzynce nie ma awiza.\nWciśnięcie X powoduje przesunięcie daty kolejnego sprawdzenia o 7 dni`),
                ],
                Actions: {
                    "✅": () => this.GoTo(ManaPostalDeliveryStepState.Delivered),
                    "❌": () =>
                    {
                        this.Data.DeliveryDeadline.value = moment(this.Data.DeliveryDeadline.value).add(7, "day").toDate();
                        this.GoTo(ManaPostalDeliveryStepState.Awaiting);
                    }
                },
            },
        },
        [ManaPostalDeliveryStepState.Delivered]: {
            StateName: "Dostarczone",
            Admin: {
                Content: () => [`Pieniądze dostarczone (${this.Data.Amount.value} zł) ✅`],
            }
        },
        [ManaPostalDeliveryStepState.Cancelled]: {
            StateName: "Odwołane",
            Admin: {
                Content: () => [`Anulowano dostarczenie (paczka została zwrócona bądź wystąpił inny problem)`],
            }
        },
    };
}

